import styled from "styled-components";

export const MuiTopProgressStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
`;
